<template>
  <nav aria-label="Page navigation example" v-if="pageTotal > 1">
    <ul class="pagination">
      <!-- Previous Button -->
      <li class="page-item" :class="{ disabled: isPreviousDisabled }" @click="changePage(currentPage - 1)">
        <a class="page-link" href="#">Previous</a>
      </li>

      <!-- Page Numbers -->
      <li v-for="page in visiblePages" :key="page.number" class="page-item" :class="{ active: page.number === currentPage }">
        <a class="page-link" href="#" @click="changePage(page.number)" v-if="!page.ellipsis">{{ page.number }}</a>
        <span class="page-link" v-else>...</span>
      </li>

      <!-- Next Button -->
      <li class="page-item" :class="{ disabled: isNextDisabled }" @click="changePage(currentPage + 1)">
        <a class="page-link" href="#">Next</a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    pageTotal: { type: Number, required: true },
    value: { type: Number, required: true }
  },
  computed: {
    currentPage() {
      return this.value;
    },
    isPreviousDisabled() {
      return this.currentPage <= 1;
    },
    isNextDisabled() {
      return this.currentPage >= this.pageTotal;
    },
    visiblePages() {
      const pages = [];
      //const maxPages = 5;
      const startPage = Math.max(1, this.currentPage - 2);
      const endPage = Math.min(this.pageTotal, this.currentPage + 2);

      if (startPage > 1) {
        pages.push({ number: 1 });
        if (startPage > 2) {
          pages.push({ ellipsis: true });
        }
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push({ number: i });
      }

      if (endPage < this.pageTotal) {
        if (endPage < this.pageTotal - 1) {
          pages.push({ ellipsis: true });
        }
        pages.push({ number: this.pageTotal });
      }

      return pages;
    }
  },
  methods: {
    changePage(page) {
      if (page < 1 || page > this.pageTotal) return;
      this.$emit('changePage', page);
    }
  }
}
</script>

<style scoped>
.page-item.disabled .page-link {
  cursor: not-allowed;
  opacity: 0.5;
}
.page-item.active .page-link {
  background-color: #007bff;
  color: white;
}
</style>